import { styled } from 'styled-components';

export const Image = styled.img<{ size: number }>`
    width: ${({ size }) => size}px;
    height: auto;
`;
